import React, { useEffect, useState, useRef } from "react";
import './compact-eval.css';
import { useNavigate } from 'react-router-dom';
import useAuth from '../useAuth';
// import style 
import "../../styles/ConsultantEvaluation.css";


export default function CreateSelfEvaluation() {
     const [questions, setQuestions] = useState([]);
     const [loading, setLoading] = useState(true);
     const [saving, setSaving] = useState(false);
     const getCurrentQuarter = () => {
          const m = new Date().getMonth(); // 0-11
          if (m <= 2) return "Q1";
          if (m <= 5) return "Q2";
          if (m <= 8) return "Q3";
          return "Q4";
     };

     const getLastCompletedQuarter = () => {
          const m = new Date().getMonth(); // 0-11
          const currentQ = Math.floor(m / 3) + 1; // 1-4
          let lastQ = currentQ - 1;
          if (lastQ < 1) lastQ = 4;
          return `Q${lastQ}`;
     };

     const [form, setForm] = useState({
          emp_code: "",
          employee_code: "",
          quarter: "",
          centre: "",
          created_by: "",
          specialty: "",
          timing: "",
          year: String(new Date().getFullYear()),
          mobile: '',
          employment_type: '',
          doj: '',
          vdc_exp: '',
          dept: '',
          overall_comment: '',
          is_submitted: 'N',
     });
     const initialForm = {
          emp_code: "",
          employee_code: "",
          quarter: "",
          centre: "",
          created_by: "",
          emp_name: "",
          specialty: "",
          timing: "",
          year: "",
          mobile: '',
          employment_type: '',
          doj: '',
          vdc_exp: '',
          dept: '',
          overall_comment: '',
          is_submitted: 'N',
     };

     const [details, setDetails] = useState({});
     const [detailErrors, setDetailErrors] = useState({});
     const commentRefs = useRef({});
     const [blockingCommentFor, setBlockingCommentFor] = useState(null);
     const [message, setMessage] = useState(null);
     const navigate = useNavigate();
     const [showQuestions, setShowQuestions] = useState(false);
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const { fetchProfile } = useAuth();
     const existsAlertShownRef = useRef(false);

     // helper to map points to pastel background colors
     const getBgColor = (points) => {
          switch (String(points)) {
               case "3":
                    return "#e6ffed"; // pastel green
               case "2":
                    return "#fff8e6"; // pastel orange
               case "1":
                    return "#ffecec"; // pastel red
               case "0":
                    return "#f3f3f3"; // light gray
               default:
                    return "";
          }
     };

     const getTextColor = (points) => {
          switch (String(points)) {
               case "3":
                    return "#1f7a1f";
               case "2":
                    return "#a05a00";
               case "1":
                    return "#b30000";
               case "0":
                    return "#666666";
               default:
                    return "inherit";
          }
     };

     const computeVdc = (dojStr) => {
          if (!dojStr) return '';
          let ds = String(dojStr).trim();
          if (!ds || ds === '0000-00-00' || ds === '0000-00-00 00:00:00') return '';
          try {
               let d = null;
               if (/^\d{4}-\d{2}-\d{2}/.test(ds)) {
                    d = new Date(ds.split(' ')[0]);
               } else if (/^\d{2}-\d{2}-\d{4}$/.test(ds)) {
                    const [dd, mm, yyyy] = ds.split('-');
                    d = new Date(`${yyyy}-${mm}-${dd}`);
               } else {
                    const tmp = new Date(ds);
                    if (!isNaN(tmp.getTime())) d = tmp;
               }
               if (!d || isNaN(d.getTime())) return '';
               const now = new Date();
               const months = (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth());
               if (months < 0) return '';
               const yrs = Math.floor(months / 12);
               const rem = months % 12;
               const parts = [];
               if (yrs > 0) parts.push(`${yrs} year${yrs > 1 ? 's' : ''}`);
               if (rem > 0) parts.push(`${rem} month${rem > 1 ? 's' : ''}`);
               return parts.length > 0 ? parts.join(' ') : '0 months';
          } catch (e) {
               return '';
          }
     };

     const pickDeptFromEmp = (emp = {}, fallback = '') => {
          const candidates = [
               emp?.department_category,
               emp?.main_department,
               emp?.mainDepartment,
               emp?.main_dept,
               emp?.dept,
               emp?.dept_name,
               emp?.department,
               emp?.ou_name,
               fallback,
          ];
          for (const c of candidates) {
               if (c === undefined || c === null) continue;
               const s = String(c).trim();
               if (s !== '') return s;
          }
          return '';
     };

     // loader for questions (fetched on load in background)
     const loadQuestions = (attempt = 1) => {
          setLoading(true);
          const url = `${baseUrl}/getConsultantEvaluationQuestions`;
          const headersBase = { "Accept": "application/json" };
          const token = localStorage.getItem("token");
          const headers = token ? { ...headersBase, Authorization: `Bearer ${token}` } : headersBase;

          fetch(url, { method: "GET", headers })
               .then((r) => r.json())
               .then((data) => {
                    if (Array.isArray(data)) {
                         setQuestions(data);
                         const init = {};
                         data.forEach((q) => {
                              init[q.id] = { question_id: q.id, points: "", comments: "" };
                         });
                         setDetails(init);
                         setLoading(false);
                    } else {
                         if (attempt === 1) {
                              console.warn('Questions payload invalid, retrying...');
                              setTimeout(() => loadQuestions(2), 1000);
                         } else {
                              console.error('Failed to load questions: invalid payload');
                              setQuestions([]);
                              setLoading(false);
                         }
                    }
               })
               .catch((err) => {
                    if (attempt === 1) {
                         console.warn('Failed to load questions, retrying...', err);
                         setTimeout(() => loadQuestions(2), 1000);
                    } else {
                         console.error('Failed to load questions after retry', err);
                         setQuestions([]);
                         setLoading(false);
                    }
               });
     };

     useEffect(() => {
          // fetch questions in background on component mount
          loadQuestions(1);
     }, []);

     // On mount, populate form from userProfile in storage if present
     useEffect(() => {
          const initFromProfile = async () => {
               try {
                    // try to read cached profile
                    let raw = sessionStorage.getItem('userProfile') || localStorage.getItem('userProfile');

                    // If not present, attempt to fetch profile (will populate sessionStorage)
                    if (!raw) {
                         const token = sessionStorage.getItem('token') || localStorage.getItem('token');
                         if (token && typeof fetchProfile === 'function') {
                              await fetchProfile(false).catch(() => null);
                              raw = sessionStorage.getItem('userProfile') || localStorage.getItem('userProfile');
                         }
                    }

                    if (!raw) return;
                    const profile = JSON.parse(raw);
                    if (!profile) return;

                    const profileEmpCode = profile.employee_code || profile.emp_code || profile.user_code || '';
                    const profileName = profile.employee_name || profile.emp_name || profile.user_name || '';
                    const profileCentre = profile.location_name || profile.centre || profile.location || '';
                    const profileSpecialty = profile.speciality || profile.specialty || '';
                    const profileCreator = profile.user_code || profile.emp_id || profile.userId || localStorage.getItem('userId') || '';

                    // derive timing from shift_details if present
                    let profileTiming = '';
                    try {
                         const shift = (profile.shift_details && profile.shift_details.length && profile.shift_details[0]) || null;
                         if (shift && shift.in_time && shift.out_time) {
                              const fmt = (t) => (t || '').toString().split(':').slice(0, 2).join(':');
                              profileTiming = `${fmt(shift.in_time)} - ${fmt(shift.out_time)}`;
                         }
                    } catch (e) {
                         profileTiming = '';
                    }

                    setForm((f) => ({
                         ...f,
                         emp_code: profileEmpCode,
                         employee_code: profileEmpCode,
                         emp_name: profileName,
                         centre: profileCentre,
                         specialty: profileSpecialty,
                         created_by: profileCreator,
                         timing: profileTiming,
                    }));

                    // If we have an emp_code, pre-validate and fetch details so questions can render
                    if (profileEmpCode) {
                         const url = `${baseUrl}/getEmployeeDetails/${encodeURIComponent(profileEmpCode)}`;
                         const headers = { Accept: 'application/json' };
                         const token = localStorage.getItem('token') || sessionStorage.getItem('token');
                         if (token) headers['Authorization'] = `Bearer ${token}`;

                         fetch(url, { method: 'GET', headers })
                              .then((r) => r.json())
                              .then((data) => {
                                   const emp = Array.isArray(data) ? data[0] : data;

                                   if (emp && Object.keys(emp).length > 0) {
                                        const resolvedEmployment = emp.employment_type || emp.emp_type || emp.employment || '';
                                        setForm((f) => ({
                                             ...f,
                                             emp_name: emp.employee_name || f.emp_name || '',
                                             centre: emp.location_name || f.centre || '',
                                             mobile: f.mobile || emp.mobile || '',
                                             doj: emp.doj || f.doj || '',
                                             dept: pickDeptFromEmp(emp, f.dept || ''),
                                             employment_type: f.employment_type || resolvedEmployment,
                                        }));
                                        setShowQuestions(true);
                                        checkExistingEvaluation(profileEmpCode, form.quarter, form.year);
                                   }
                              })
                              .catch((err) => console.debug('Auto-load employee details failed', err));
                    }
               } catch (err) {
                    console.debug('Failed to parse userProfile from storage', err);
               }
          };

          initFromProfile();
     }, [fetchProfile, baseUrl]);

     // check whether an evaluation already exists for emp_code + quarter + year
     const checkExistingEvaluation = async (empCode, quarter, year) => {
          if (!empCode || !quarter || !year) return false;
          const url = `${baseUrl}/checkExistingEvaluation/${encodeURIComponent(empCode)}/${encodeURIComponent(quarter)}/${encodeURIComponent(year)}`;
          const headers = { "Accept": "application/json" };
          const token = localStorage.getItem("token");
          if (token) headers["Authorization"] = `Bearer ${token}`;
          try {
               const res = await fetch(url, { method: "GET", headers });
               if (!res.ok) return false;
               const data = await res.json();
               let exists = false;
               if (Array.isArray(data)) exists = data.length > 0;
               else if (data && typeof data === "object") {
                    if ("exists" in data) exists = !!data.exists;
                    else if ("id" in data) exists = true;
                    else exists = Object.keys(data).length > 0;
               } else {
                    exists = Boolean(data);
               }
               if (exists) {
                    // try to extract an existing evaluation id to navigate to view it
                    let existingId = null;
                    if (Array.isArray(data) && data.length > 0) {
                         existingId = data[0].id || data[0].evaluation_id || data[0].eval_id || null;
                    } else if (data && typeof data === 'object') {
                         existingId = data.id || data.evaluation_id || data.eval_id || null;
                    }

                    if (existingId) {
                         // navigate to existing evaluation view instead of clearing the form
                         navigate(`/view-self-evaluations/${existingId}`);
                         return true;
                    }

                    if (!existsAlertShownRef.current) {
                         existsAlertShownRef.current = true;
                         alert(`An evaluation already exists for ${empCode} (${quarter} ${year}).`);
                    }

                    // keep emp_code in form but hide questions (user cannot create a duplicate)
                    setShowQuestions(false);
                    setLoading(false);
                    setMessage(null);
                    setSaving(false);
               }
               return exists;
          } catch (err) {
               console.error("checkExistingEvaluation failed", err);
               return false;
          }
     };

     function handleFieldChange(e) {
          const { name, value } = e.target;
          setForm((f) => {
               const newForm = { ...f, [name]: value };
               // if quarter/year changed and employee code present, check for existing evaluation
               if ((name === "quarter" || name === "year") && newForm.emp_code && newForm.emp_code.toString().trim() !== "") {
                    checkExistingEvaluation(newForm.emp_code.toString().trim(), newForm.quarter, newForm.year);
               }
               // reset exists alert when emp_code changes so future checks can show again
               if (name === 'emp_code') {
                    existsAlertShownRef.current = false;
               }
               return newForm;
          });
     }

     function handleDetailChange(questionId, field, value) {
          setDetails((d) => ({ ...d, [questionId]: { ...d[questionId], [field]: value } }));
     }

     //  function to fetech employee details on change of emp code using the route /getEmployeeDetails/:empCode
     // validate emp_code when user finishes entering it (onBlur)
     async function validateEmpCode() {
          const code = form.emp_code && form.emp_code.toString().trim();
          if (!code) {
               setForm((f) => ({ ...f, emp_name: "", centre: "" }));
               setShowQuestions(false);
               return;
          }

          const url = `${baseUrl}/getEmployeeDetails/${code}`;
          const headers = { "Accept": "application/json" };
          const token = localStorage.getItem("token");
          if (token) headers["Authorization"] = `Bearer ${token}`;

          try {
               const res = await fetch(url, { method: "GET", headers });
               const data = await res.json();
               if (Array.isArray(data) && data.length > 0) {
                    const emp = data[0];
                    const resolvedEmployment = emp.employment_type || emp.emp_type || emp.employment || '';
                    setForm((f) => ({ ...f, emp_name: emp.employee_name || "", centre: emp.location_name || f.centre || "", mobile: f.mobile || emp.mobile || "", doj: emp.doj || f.doj || "", dept: pickDeptFromEmp(emp, f.dept || ""), employment_type: f.employment_type || resolvedEmployment }));
                    // allow rendering questions now that emp_code is validated
                    setShowQuestions(true);
                    // ensure we don't duplicate an existing evaluation for selected quarter/year
                    checkExistingEvaluation(code, form.quarter, form.year);
               } else {
                    alert(`Employee code ${code} does not exist`);
                    setForm((f) => ({ ...f, emp_code: "", emp_name: "", centre: "" }));
                    setQuestions([]);
                    setLoading(false);
                    setShowQuestions(false);
               }
          } catch (err) {
               console.error("Failed to validate employee code", err);
               alert("Employee code not found. Please try again.");
               setForm((f) => ({ ...f, emp_name: "", centre: "" }));
               setShowQuestions(false);
          }
     }

     async function handleSubmit(e, finalSubmit = false) {
          if (e && e.preventDefault) e.preventDefault();
          setMessage(null);

          // validate: when points is Non Satisfactory (1) or Nothing is done (0), comments are mandatory
          const errors = {};
          Object.entries(details || {}).forEach(([qid, it]) => {
               const pts = it && (it.points === '' || it.points == null) ? '' : it.points;
               if (pts !== '' && (String(pts) === '1' || String(pts) === '0')) {
                    if (!it.comments || String(it.comments).trim() === '') {
                         errors[qid] = 'Comments required for low rating';
                    }
               }
          });
          if (Object.keys(errors).length > 0) {
               setDetailErrors(errors);
               setMessage({ type: 'error', text: 'Please provide comments for items marked Non Satisfactory / Nothing is done.' });
               return;
          } else {
               setDetailErrors({});
          }

          if (!form.emp_code) {
               setMessage({ type: "error", text: "Employee code is required." });
               return;
          }

          const creator = form.created_by || localStorage.getItem("userId") || null;

          // compute total points (treat empty or invalid as 0)
          const totalPoints = Object.values(details).reduce((s, it) => {
               const v = parseInt(it.points, 10);
               return s + (Number.isNaN(v) ? 0 : v);
          }, 0);

          const payloadForm = { ...form };
          if (finalSubmit) payloadForm.is_submitted = 'Y';

          const payload = {
               ...payloadForm,
               details: Object.values(details),
               total_points: totalPoints,
          };

          // ensure vdc_exp and dept are present in payload (fallback compute vdc from doj)
          try {
               payload.vdc_exp = (payload.vdc_exp || '').toString().trim() || computeVdc(payload.doj || form.doj || '');
          } catch (e) { payload.vdc_exp = payload.vdc_exp || ''; }
          const pickDept = (obj, fallback) => {
               const candidates = [
                    obj?.department_category,
                    obj?.main_department,
                    obj?.mainDepartment,
                    obj?.main_dept,
                    obj?.dept,
                    obj?.dept_name,
                    obj?.department,
                    fallback
               ];
               for (const c of candidates) {
                    if (c === undefined || c === null) continue;
                    const s = String(c).trim();
                    if (s !== '') return s;
               }
               return '';
          };
          payload.dept = pickDept(payload, form.dept || '');

          if (creator) {
               payload.created_by = creator;
          } else {
               delete payload.created_by;
          }

          setSaving(true);
          try {
               const token = localStorage.getItem("token");
               const headers = { "Content-Type": "application/json" };
               if (token) headers["Authorization"] = `Bearer ${token}`;

               const url = `${baseUrl}/createConsultantEvaluation`;
               const res = await fetch(url, {
                    method: "POST",
                    headers,
                    body: JSON.stringify(payload),
               });

               const json = await res.json();
               if (res.ok) {
                    if (finalSubmit) {
                         // set submitted flag locally
                         setForm(f => ({ ...f, is_submitted: 'Y' }));
                         // redirect to list page after final submission
                         navigate('/consultant-evaluations', { state: { message: { type: 'success', text: `Submitted (id: ${json.id}, points: ${json.total_points})` } } });
                         return;
                    }
                    // for drafts, navigate to view page with success message
                    navigate(`/view-self-evaluations/${json.id}`, { state: { message: { type: 'success', text: `Saved (id: ${json.id}, points: ${json.total_points})` } } });
                    return; // navigation will display the saved view
               } else {
                    setMessage({ type: "error", text: json.error || JSON.stringify(json) });
               }
          } catch (err) {
               console.error(err);
               setMessage({ type: "error", text: "Request failed" });
          } finally {
               setSaving(false);
          }
     }

     function handleFinalSubmit() {
          const confirmMsg = 'By submitting you will not be able to edit this form. This is the final submission. Do you want to continue?';
          if (!window.confirm(confirmMsg)) return;
          handleSubmit(null, true);
     }




     return (
          <div className="consultant-eval compact">


               <form onSubmit={handleSubmit}>
                    <div className="row">
                         <div className="col-sm-4">   <h2>Create Self Consultant Evaluation</h2></div>
                         <div className="col-sm-8 ">
                              <div className=" row">

                                   <input name="emp_code" type='hidden' value={form.emp_code} onChange={handleFieldChange} onBlur={validateEmpCode} required />
                                   <input name="centre" type="hidden" value={form.centre ?? ""} readOnly />
                                   <input name="emp_name" type="hidden" value={form.emp_name ?? ""} onChange={handleFieldChange} readOnly />
                                   <input name="specialty" type="hidden" required value={form.specialty} onChange={handleFieldChange} />
                                   <input name="timing" type="hidden" required value={form.timing} onChange={handleFieldChange} />
                                   <input name="mobile" type="hidden" value={form.mobile ?? ""} onChange={handleFieldChange} />
                                   <input name="employment_type" type="hidden" value={form.employment_type ?? ""} onChange={handleFieldChange} />
                                   <input name="doj" type="hidden" value={form.doj ?? ""} onChange={handleFieldChange} />
                                   <input name="vdc_exp" type="hidden" value={form.vdc_exp ?? ""} onChange={handleFieldChange} />
                                   <input name="dept" type="hidden" value={form.dept ?? ""} onChange={handleFieldChange} />
                                   <input name="is_submitted" type="hidden" value={form.is_submitted ?? 'N'} onChange={handleFieldChange} />

                                   <div className="col-sm-2  ">
                                        <select className="col-sm-2 " required name="quarter" value={form.quarter} onChange={handleFieldChange}>
                                             <option value="">Select quarter</option>
                                             <option value="Q1">Jan - Mar</option>
                                             <option value="Q2">Apr - Jun</option>
                                             <option value="Q3">Jul - Sep</option>
                                             <option value="Q4">Oct - Dec</option>
                                        </select>
                                   </div>

                                   <div className="col-sm-2  "><select name="year" readOnly required value={form.year} onChange={handleFieldChange}>
                                        <option value="">Select year</option>
                                        {Array.from({ length: 1 }, (_, i) => {
                                             const year = new Date().getFullYear() - i;
                                             return <option key={year} value={year}>{year}</option>;
                                        })}
                                   </select></div>

                              </div>
                         </div>
                    </div>

                    {!showQuestions ? (
                         <div>Please enter Employee Code to view tasks.</div>
                    ) : loading ? (
                         <div>Loading questions…</div>
                    ) : (
                         <div className="question-list">
                              {questions.length === 0 && <div>No questions available.</div>}
                              {questions.map((q, idx) => (
                                   <div key={q.id} className="question-item">
                                        <div className="q-index">{q.display_order || idx + 1}.</div>
                                        <div className="question-text">{q.question_text}</div>
                                        <div className="points-col">
                                             <label className="points-label">
                                                  <span className="sr-only">Points for {q.question_text}</span>
                                                  <select
                                                       value={(details[q.id]?.points === "" || details[q.id]?.points == null) ? "" : details[q.id].points.toString()}
                                                       onChange={(e) => {
                                                            // Prevent changing other rows while a comment is required
                                                            if (blockingCommentFor && blockingCommentFor !== q.id) {
                                                                 setMessage({ type: 'error', text: 'Please add comments for the highlighted item before proceeding.' });
                                                                 return;
                                                            }
                                                            const val = e.target.value;
                                                            // if selecting Non Satisfactory(1) or Nothing(0) and comment is empty, force comment immediately
                                                            const existingComments = (details[q.id]?.comments || '').toString().trim();
                                                            if ((val === '1' || val === '0') && !existingComments) {
                                                                 // set points, mark error, block other interactions and focus comment
                                                                 if (val === '') handleDetailChange(q.id, 'points', '');
                                                                 else {
                                                                      const v = parseInt(val, 10);
                                                                      handleDetailChange(q.id, 'points', Number.isNaN(v) ? '' : v);
                                                                 }
                                                                 setDetailErrors(prev => ({ ...prev, [q.id]: 'Comments required for this selection' }));
                                                                 setBlockingCommentFor(q.id);
                                                                 setMessage({ type: 'error', text: 'Please add comments for items marked Non Satisfactory / Nothing is done.' });
                                                                 setTimeout(() => {
                                                                      const el = commentRefs.current[q.id];
                                                                      if (el && typeof el.focus === 'function') el.focus();
                                                                 }, 50);
                                                                 return;
                                                            }

                                                            if (val === "") {
                                                                 handleDetailChange(q.id, "points", "");
                                                            } else {
                                                                 const v = parseInt(val, 10);
                                                                 handleDetailChange(q.id, "points", Number.isNaN(v) ? "" : v);
                                                            }
                                                            // clear error/block if user selected a non-blocking value
                                                            setDetailErrors(prev => { const next = { ...prev }; delete next[q.id]; return next; });
                                                            if (blockingCommentFor === q.id) setBlockingCommentFor(null);
                                                       }}
                                                       className="points-input"
                                                       style={{ backgroundColor: getBgColor(details[q.id]?.points), color: getTextColor(details[q.id]?.points) }}
                                                       aria-label={`Points for ${q.question_text}`}
                                                       required
                                                  >
                                                       <option value=""> Select Points</option>
                                                       <option value="3" style={{ color: 'green' }}>Good</option>
                                                       <option value="2" style={{ color: 'orange' }}>Satisfactory</option>
                                                       <option value="1" style={{ color: 'red' }}>Non Satisfactory</option>
                                                       <option value="0" style={{ color: 'gray' }}>Nothing is done</option>
                                                  </select>
                                             </label>
                                        </div>

                                        <div className="comments-col">
                                             <input
                                                  ref={el => { commentRefs.current[q.id] = el; }}
                                                  value={details[q.id]?.comments ?? ""}
                                                  onChange={(e) => {
                                                       const val = e.target.value;
                                                       handleDetailChange(q.id, "comments", val);
                                                       // clear error and unblock when comment is provided
                                                       if (val && val.toString().trim() !== '') {
                                                            setDetailErrors(prev => { const next = { ...prev }; delete next[q.id]; return next; });
                                                            if (blockingCommentFor === q.id) setBlockingCommentFor(null);
                                                       }
                                                  }}
                                                  placeholder="Comments / Description"
                                                  className="comments-input"
                                                  style={{ backgroundColor: getBgColor(details[q.id]?.points), maxWidth: '300px', borderColor: detailErrors[q.id] ? '#c74343' : undefined }}
                                             />
                                             {detailErrors[q.id] && (
                                                  <div style={{ color: '#c74343', fontSize: 12, marginTop: 6 }}>This comment is required for the selected rating.</div>
                                             )}
                                        </div>
                                   </div>
                              ))}

                              {/* Total points row */}
                              <div className="question-item" style={{ fontWeight: 700 }}>
                                   <div className="q-index"></div>
                                   <div className="question-text" >
                                        <span style={{ float: "right !important" }}> Total Points (45) </span></div>
                                   <div className="points-col" >
                                        <input name="total_points"
                                             value={Object.values(details).reduce((s, it) => {
                                                  const v = parseInt(it.points, 10);
                                                  return s + (Number.isNaN(v) ? 0 : v);
                                             }, 0)} readOnly className="points-input" />
                                   </div>
                                   <div className="comments-col"></div>
                              </div>
                         </div>
                    )}

                    {form.is_submitted !== 'Y' && form.quarter && (
                         <div className="form-actions">
                              <button type="submit" className="btn primary" disabled={saving}>{saving ? "Saving…" : "Save as Draft"}</button>
                              <button type="submit" className="btn info" style={{ marginLeft: 8 }} onClick={handleFinalSubmit} disabled={saving}>{saving ? 'Saving…' : 'Submit'}</button>
                         </div>
                    )}
               </form>
          </div>
     );
}
